import { Navigate, useLocation } from 'react-router-dom';

// When running locally at site root, old /tsr bookmarks still hit the dev server.
export default function LegacyTsrRedirect() {
  const location = useLocation();
  const target = location.pathname.replace(/^\/tsr/, '') || '/';
  return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
}
